<script>
import appConfig from '@/app.config'
import Table from '../../../../components/common/table/simpleTable/SimpleTable.vue'
import TableHeader from '../../../../components/common/table/simpleTable/TableHeader.vue'
import Pagination from '../../../../components/common/table/simpleTable/Pagination.vue'
import userDataProvider from '../../../../services/user'
import { searchComboMixins, userMixins } from '../../../../utils/mixins'
import Loader from '../../../../components/common/loader.vue'

export default {
  page: {
    title: 'لیست ها',
    meta: [
      {
        name: 'list',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Table,
    TableHeader,
    Pagination,
    Loader,
  },
  mixins: [userMixins, searchComboMixins],
  props: {
    tableData: {
      type: Object,
    },
    tableId: {
      type: String,
    },
    wannaUpdate: { type: Boolean },
    loading: {
      type: Boolean,
      default: false,
    },
    noNeedToChangeRoute: {
      type: Boolean,
      default: false,
    },
      clickToChangeRoute: {
      default: true,
      type: Boolean,
    },
      searchVisible: {
      default: true,
      type: Boolean,
    },
     heightStyle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      componentKey: 0,
      dropDownListItems: [
        { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true },
        { id: 2, count: 20, value: 'نمایش 20 تایی', isDefault: false },
        { id: 3, count: 50, value: 'نمایش 50 تایی', isDefault: false },
      ],
      flag: true,
    }
  },
  computed: {
    routerValue() {
      return this.$route.params.id
    },
    hasButton() {
      return this.tableData.data.addRowPage
      // return (this.$route.name === 'transactions-fromListsWallet' || this.$route.name === 'transactions-fromUserManagement') ? () :this.tableData.data.addRowPage
    },
    addRow() {
      if (this.tableData.data.addRowPage.option !== null && this.tableData.data.addRowPage.option.type === 0) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    addButton() {
      if (this.tableData.data.addRowPage.title != null) {
        if (this.addRow) {
          this.$emit('modalName', this.tableData.data.addRowPage.key)
          return
        }
        if (this.tableData.data.addRowPage.key === 'invoice') {
          this.$store.commit(`searchCombo/SET_SELECTED_CUSTOMER`, { key: this.$route.params.id, value: this.userDetails.peopleGlobalDto.fullName })
        }
        if (this.tableData.data.addRowPage.key === 'address') {
          this.$store.commit(`user/SET_SELECTED_CUSTOMER`, { key: this.$route.params.id })
        }
        setTimeout(() => {
          this.$router.push({ path: `/list/${this.tableData.data.addRowPage.key}/add` })
          return
        }, 500)
      }
    },
    updateTable(e) {
      // this.flag = false
      // this.loading = true
      // const apiUrl = this.userProfileMenuItems.find(item => item.key == e.tableId).url

      // // this.$nextTick(() => {
      //   // this.flag = true
      //   userDataProvider
      //     .getUserProfileItemsData(apiUrl, { peopleId: this.routerValue, searchDto: { pageNumber: e.page, pageSize: e.pageSize.count, filters: e.filters, search: e.query } })
      //     .then(res => {
      //       if(res.status === 200) {
      //         this.tableData = res.data

      //         setTimeout(() => {
      //           this.forceRerender()
      //           this.loading = false
      //         }, 1000);
      //       }
      //     })
      // // })
      this.$emit('tableObj', e)
    },
    forceRerender() {
      this.componentKey += 1
    },
  },
  watch: {
    wannaUpdate(val) {
      if (val === true) {
        this.forceRerender()
      }
    },
  },
  created() {
    console.log('poori', this.tableData);
  }
}
</script>
<template>
  <div class="" style="overflow-x: auto">
    <div class="col-12">
      <div class="card" :style="heightStyle">
        <div class="card-body">
          <TableHeader
            :isActive="false"
            :searchVisible="searchVisible"
            :button="hasButton !== undefined ? hasButton.title === null ? false : hasButton : null"
            :buttonTitle="hasButton !== undefined ? hasButton.title !== null ? hasButton.title : '' : null"
            :buttonFunction="hasButton !== undefined && addButton"
            bottomTitle
            :title="tableData.data.name"
            actionClass="d-flex align-items-end justify-content-between"
            :notDropdown="true"
            :tableId="tableId"
            @tableObj="updateTable($event)"
          />
          <!-- :filterList="tableData.data.filters"  -->
          <!-- TODO -->
          <Table
            :fields="tableData.data.fields"
            :rows="tableData.data.rows"
            :selectRoute="hasButton.link != null && `/list/${hasButton.key}/detail`"
            :clickToChangeRoute="clickToChangeRoute"
            :noNeedToChangeRoute="noNeedToChangeRoute"
            :key="componentKey"
            :tableId="tableId"
            :heightStyle="heightStyle"
            @selectedRow="$emit('selectedRow',$event)"
          >
            <template v-slot:emptyTable>
              <Loader :loading="loading" />
            </template>
          </Table>

          <Pagination :tableId="tableId" :paginationData="tableData.pagination" @tableObj="updateTable($event)" :dropDownListItems="dropDownListItems" />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
::v-deep .dropdown-menu.show {
  top: -85px !important;
}
</style>